import React from "react"
import { includes } from "lodash"
import { ArrowForward } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import { getHighlightedText, NON_SEARCHABLE_SECONDARY_TYPES } from "../helpers"

interface SecondaryTextProps {
  secondary: React.ReactElement
  detail: string
  type: string
  value: string
  isHovering?: boolean
}

export function SecondaryText({ secondary, detail, type, value, isHovering }: SecondaryTextProps) {
  if (type === "portfolio" && isHovering) {
    return <span className="user-action-info">
      <ArrowForward />
      Open Portfolio
    </span>
  }
  if (!detail) return getHighlightedText(secondary, value)

  const secondaryElement = includes(NON_SEARCHABLE_SECONDARY_TYPES, type) ? secondary : getHighlightedText(secondary, value)
  const detailElement = <span className="item-detail">{getHighlightedText(detail, value)}</span>
  return <span className="text-overflow-dynamic-container">
    <span className="text-overflow-dynamic-ellipsis">{secondaryElement} - <OPTooltip placement="bottom-start" classes={{ popper: "large-tooltip" }} title={detailElement}>{detailElement}</OPTooltip></span>
  </span>
}
